export default "__VITE_ASSET__Cks$hqwz__"